import { Button, guardedLeave } from "../ui";
import { useNextT } from "../i18n";
import { useViewingAs } from "../bridges/frame";
import { useCurrentUser } from "../bridges/session";
import { useAccess } from "../access/api";
import { Icon } from "./icons";
import { useViewingAsMode } from "./viewingAsMode";
import s from "./ViewingAsStrip.module.scss";

/** Own strip at the top: pushes the frame down, never covers anything (4.1). Board 94: staff viewing as someone, changes recorded as made by staff. */
export const ViewingAsStrip = () => {
  const { t } = useNextT();
  const v = useViewingAs();
  const user = useCurrentUser() as any;
  const { data } = useAccess();
  // Walkthrough p9: "Changes you make are recorded…" only once changes are on (look-only makes none).
  const mode = useViewingAsMode(v.active || !!data?.viewingAs).data;
  const lookOnly = !!mode?.active && !!mode.look_only;
  // Either side knows: the parked staff token (v) or the access answer (viewingAs).
  if (!v.active && !data?.viewingAs) return null;
  const name = v.name || `${user?.first_name ?? ""} ${user?.last_name ?? ""}`.trim();
  return (
    <section className={s.strip} aria-label={t("shell.viewing.label")}>
      <Icon name="eye" size={18} />
      <span>
        <strong>{t("shell.viewing.staff")}</strong> · {t("shell.viewing.as")} <strong><bdi>{name}</bdi></strong>.{lookOnly ? null : <> {t("shell.viewing.recorded")}</>}
      </span>
      <Button variant="secondary" onClick={() => guardedLeave(v.exit)}>{t("shell.viewing.stop")}</Button>
    </section>
  );
};
